import qs from 'qs'
import config from '../../config'
import { buildGetQuery } from '../../util'
import { QueryObserverOptions } from '@tanstack/react-query'

import { ITrainingGroup, IGetRequestObject } from '../../interfaces'

type QueryObject = {
  activeOnly?: boolean
}

const getTrainingGroupsDetailsRequest = (
  params: undefined,
  queryObject: QueryObject | undefined,
): IGetRequestObject => {
  const queryString = qs.stringify(queryObject, { addQueryPrefix: true })
  return {
    method: 'get',
    url: `${config.baseUrl}/TrainingGroups${queryString}`,
  }
}

const useTrainingGroupsDetailsQueryBase = buildGetQuery<
  undefined,
  QueryObject | undefined,
  ITrainingGroup[] | undefined
>({
  getRequest: getTrainingGroupsDetailsRequest,
  getQueryKey: (params, queryObject) => [
    'training-groups-details',
    queryObject?.activeOnly,
  ],
})

const useTrainingGroupsDetailsQuery = (
  queryObject?: QueryObject,
  options?: QueryObserverOptions<ITrainingGroup[] | undefined, Error>,
) => {
  const trainingGroupsDetailsQuery = useTrainingGroupsDetailsQueryBase(
    undefined,
    queryObject,
    options,
  )
  return { ...trainingGroupsDetailsQuery }
}

export default useTrainingGroupsDetailsQuery
